<template>

    <section class="grid grid-cols-[auto_1fr] gap-10">
        <card class="h-fit" padding="">
            <section class="flex flex-col gap-6 sticky top-0">
                <div class="px-8 py-4 border-b border-gray-400/50">
                    <span class="font-bold">
                        Dados Pessoais
                    </span>
                </div>
                <div class="flex flex-col gap-2 text-sm pt-0 p-5">
                    <span>
                        <b>Nome: </b>
                        {{ selectedUser.name }}
                    </span>
                    <span>
                        <b>Usuário: </b>
                        {{ selectedUser.username }}
                    </span>
                    <span>
                        <b>ID: </b>
                        {{ selectedUser.id }}
                    </span>
                </div>
            </section>
        </card>
        <rpm-table
            title="Gerenciar perfis"
            :columns="columns"
            :data="selectedUser.roles"
            :loading="loading"
        >
            <template #functions>
                <section class="flex flex-row-reverse w-full">
                    <rpm-button
                        class="w-6 h-6 rounded"
                        tooltip-text="Adicionar"
                        font-size="text-sm"
                        icon="fa-solid fa-plus"
                        @click="openModalAdd()"
                    />
                </section>
            </template>
            <template #actions="{item}">
                <rpm-button
                    color="red-hover"
                    tooltip-text="Excluir"
                    icon="fa-solid fa-trash"
                    class="h-6 w-6"
                    @click="openModalDelete(item)"
                />
            </template>
        </rpm-table>
        <rpm-modal
            header="Adicionar função ao usuário"
            class="flex flex-col gap-y-8"
            persist 
            :open="modalAdd"
            @close="modalAdd = false"
        >
            <section class="flex flex-col gap-6">
                <rpm-input 
                    type="multiselect"
                    label="Funções"
                    class="col-span-3"
                    v-model="form.roles"
                    :options="roles"
                    optionLabel="name"
                    optionValue="id"
                />
            </section>
            <section class="flex flex-row justify-center gap-6">
                <rpm-button
                    color="gray"
                    label="Cancelar"
                    @click="modalAdd = false"
                ></rpm-button>
                <rpm-button
                    label="Confirmar"
                    @click="updateRoles()" 
                ></rpm-button>
            </section>
        </rpm-modal>
        <rpm-modal
            header="Deseja excluir este perfil?"
            class="flex flex-col gap-6"
            :open="modalDelete"
            @close="modalDelete = false"
        >
            <section class="flex flex-row justify-center gap-6">
                <rpm-button
                    color="gray"
                    label="Cancelar"
                    @click="modalDelete = false"
                ></rpm-button>
                <rpm-button
                    color="red"
                    label="Excluir"
                    @click="deleteRole()"
                ></rpm-button>
            </section>
    </rpm-modal>
    </section>

</template>

<script>

import RpmTable from '#components/RpmTable.vue';
import RpmModal from '#components/RpmModal.vue';
import usersRepository from '#repositories/usersRepository';
import roleRepository from '#repositories/roleRepository.js'

export default {
    name: 'Usuário',
    components: {
        RpmTable,
        RpmModal
    },
    data() {
        return {
            selectedUser: {},
            roles: [],
            form: {},
            modalAdd: false,
            modalDelete: false,
            loading: false,
            roleToRemove: null,
            columns: [
                {
                    field: "name",
                    label: "Perfil"
                }
            ]
        }
    },
    methods: {
        async getUser(useLoading = true) {
            try {
                if(useLoading) this.loading = true;
                this.selectedUser = (await usersRepository.fetchUser(this.$route.params.id)).data;
                if(useLoading) this.loading = false;
            } catch (error) {
                this.$notify("Erro ao resgatar dados, tente novamente mais tarde.", 'error');
            }
        },

        async getRoles() {
            try {
                this.roles = (await roleRepository.getRoles()).data;
            } catch (error) {
                this.$notify("Erro ao resgatar perfis, tente novamente mais tarde.", 'error');
            }
        },
        
        openModalAdd() {
            this.modalAdd = true;
            this.form.roles = this.selectedUser.roles.map(role => role.id);
        },
        
        openModalDelete(item) {
            this.roleToRemove = item.id;
            this.modalDelete = true;
        },
        
        async updateRoles() {
            try {
                await roleRepository.updateRoles(this.form);
                this.getUser(false);
                this.modalAdd = false;
                this.$notify("Perfis alterados com sucesso!", 'success');
            } catch (error) {
                this.$notify("Ocorreu um erro ao atualizar os perfis.", 'error');
            }
        },

        async deleteRole() {
            try {
                this.form.roles = this.selectedUser.roles.filter(item => item.id !== this.roleToRemove).map(role => role.id);
                await roleRepository.updateRoles(this.form);
                this.getUser(false);
                this.modalDelete = false;
                this.$notify("Perfil removido com sucesso!", 'success');
            } catch (error) {
                this.$notify("Ocorreu um erro ao atualizar os perfis.", 'error');
            }
        },
    },
    
    async mounted() {
        await this.getUser();
        await this.getRoles();
        this.form.user = this.selectedUser.id;
    }
}

</script>